module.exports = __webpack_public_path__ + "assets/icons/ic_menu-4a04.svg";